/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {TemplateInstanceFormComponent as ɵc} from './templateinstance-form/templateinstance-form.component';
export {TemplateInstanceComponent as ɵb} from './templateinstance.component';
export {declaration as ɵa} from './templateinstance.module';
export {TemplateInstanceRoutes as ɵd} from './templateinstance.routing';